<template>
  <div>
    <Loading :loading="this.loading"></Loading>
    <div v-show="!loading" class="content-wrapper">
      <div class="container">
        <article>
          <template v-if="inspectionFlag">
            <h2 class="fs16 mt16 mb12 pl4p pr4p">コミっと車検</h2>
            <div class="border-solid-gray bg-white radius16 pd16 ml12 mr12 mt2p mb24">
              <div class="flex mb4">
                <p class="car-image radius50p">
                  <img src="/lib/images/ic_car.svg" alt="" class="car-img">
                </p>
                <div class="flex1 pl8">
                  <p class="fs14 mt4 mb4">{{ Manufacturer.manufacturer_name }} {{ firstRegistrationOnWareki.gengo }}{{ $filters.checkFirstYear(firstRegistrationOnWareki.year) }}年{{ firstRegistrationOnWareki.month }}月登録</p>
                  <p class="fs12 color-font2">車検受付ID {{ detail[0].id }}</p>
                  <p class="fs13" v-if="detail[0].status_code === 1 || detail[0].status_code === 2">見積り金額 <span class="fs16">{{ $filters.addComma(detail[0].estimate_price) }}</span>円</p>
                  <p class="fs13" v-if="detail[0].status_code === 3">見積り金額 <span class="fs16">{{ $filters.addComma(detail[0].before_maintenance_price) }}</span>円</p>
                  <p class="fs13" v-if="detail[0].status_code === 4 || detail[0].status_code === 5">精算金額 <span class="fs16">{{ $filters.addComma(detail[0].payment_price) }}</span>円</p>
                </div>
              </div>
              <hr class="hr-solid-gray mb16">

              <div class="progress-wrap-02 progress-4steps car-inspection-flow mb16">
                <ul class="progressbar-02 clearfix" v-if="detail[0].status_code === 1">
                  <li class="li-01 active"><span><img src="/lib/images/carcare_ic_status01_active.svg"></span></li>
                  <li class="li-02"><span><img src="/lib/images/carcare_ic_status02.svg"></span></li>
                  <li class="li-03"><span><img src="/lib/images/carcare_ic_status03.svg"></span></li>
                  <li class="li-04"><span><img src="/lib/images/carcare_ic_status04.svg"></span></li>
                </ul>
                <ul class="progressbar-02 clearfix" v-if="detail[0].status_code === 2">
                  <li class="li-01 passed"><span><img src="/lib/images/carcare_ic_status01.svg"></span></li>
                  <li class="li-02 active"><span><img src="/lib/images/carcare_ic_status02_active.svg"></span></li>
                  <li class="li-03"><span><img src="/lib/images/carcare_ic_status03.svg"></span></li>
                  <li class="li-04"><span><img src="/lib/images/carcare_ic_status04.svg"></span></li>
                </ul>
                <ul class="progressbar-02 clearfix" v-if="detail[0].status_code === 3">
                  <li class="li-01 passed"><span><img src="/lib/images/carcare_ic_status01.svg"></span></li>
                  <li class="li-02 passed"><span><img src="/lib/images/carcare_ic_status02.svg"></span></li>
                  <li class="li-03 active"><span><img src="/lib/images/carcare_ic_status03_active.svg"></span></li>
                  <li class="li-04"><span><img src="/lib/images/carcare_ic_status04.svg"></span></li>
                </ul>
                <ul class="progressbar-02 clearfix" v-if="detail[0].status_code === 4 || detail[0].status_code === 5">
                  <li class="li-01 passed"><span><img src="/lib/images/carcare_ic_status01.svg"></span></li>
                  <li class="li-02 passed"><span><img src="/lib/images/carcare_ic_status02.svg"></span></li>
                  <li class="li-03 passed"><span><img src="/lib/images/carcare_ic_status03.svg"></span></li>
                  <li class="li-04 active"><span><img src="/lib/images/carcare_ic_status04_active.svg"></span></li>
                </ul>
              </div>
              <p class="fs14 font-weight-bold mb20" v-if="detail[0].status_code === 1">店舗からのお電話をお待ち下さい。</p>
              <p v-else></p>
              <p class="fs13 font-weight-bold color-red2 text-center mb4" v-if="webviewMaintenance.inspection">
                誠に申し訳ありませんが、ただいまメンテナンス<br>中につき、ご利用いただくことが出来ません。<br>お時間をあけてから再度アクセスをお願い致します。
              </p>
              <div class="transparent-panel" v-else>
                <button v-on:click='inspectionTopPage(nativeData, versionData)' class="button fs16 mt8 mb16 pd16 radius200">次へ</button>
              </div>
            </div>
          </template>
          <section v-else class="section white-panel mb1p pd4">
            <p class="mb8 mt8 text-center">
              <img src="/lib/images/img_CCTop_banner_syaken.png" class="w80p" alt="コミっと車検">
            </p>
            <p class="fs13 font-weight-bold color-red2 text-center mb4" v-if="webviewMaintenance.inspection">
              誠に申し訳ありませんが、ただいまメンテナンス<br>中につき、ご利用いただくことが出来ません。<br>お時間をあけてから再度アクセスをお願い致します。
            </p>
            <ul class="flex stretch ul-col2" v-else>
              <li>
                <button v-on:click='InspectionDetailPage(ssInfo, profileInfo, nativeData, versionData)' class="button button-gray w80p pd8 radius200 fs12 mb8 pb10 pt8 ml32">詳しく見る</button>
              </li>
              <li><button v-on:click='nextPage(ssInfo, profileInfo, nativeData, versionData)' class="button button-green w80p pd8 radius200 fs12 mb8 pb10 pt8 mr32">無料で3分見積り</button></li>
            </ul>
          </section>
          <section class="section white-panel mb1p pd4">
            <p class="mb8 mt8 text-center">
              <img src="/lib/images/img_CCTop_banner_lease.png" class="w80p" alt="コスモMyカーリース">
            </p>
            <p class="fs13 font-weight-bold color-red2 text-center mb4" v-if="webviewMaintenance.carLease">
              誠に申し訳ありませんが、ただいまメンテナンス<br>中につき、ご利用いただくことが出来ません。<br>お時間をあけてから再度アクセスをお願い致します。
            </p>
            <p v-else>
              <button v-on:click='leaseTopPage(nativeData, versionData)' class="button button-green w80p pd8 radius200 fs14 pb10 pt8">おすすめの車を見る</button>
            </p>
          </section>
          <section class="section white-panel mb1p pd4" v-if="mpDisabled">
            <div class="timy-section mb8 mt8 text-center">
              <img src="/lib/images/maintenance-pack _image.png" class="w80p">
              <p class="text-left ml12 fs13 color-white font-weight-bold">月額500円～のサブスクリプションで<br>車のメンテナンス！</p>
            </div>
            <p class="fs13 font-weight-bold color-red2 text-center mb4" v-if="webviewMaintenance.maintenancePack">
              誠に申し訳ありませんが、ただいまメンテナンス<br>中につき、ご利用いただくことが出来ません。<br>お時間をあけてから再度アクセスをお願い致します。
            </p>
            <p v-else>
              <button class="button button-green w80p pd8 radius200 fs14 pb10 pt8" v-on:click='maintenancePackTopPage(nativeData, ssInfo.ss_code, versionData)' v-bind:disabled="this.moveMpTopButtonDisabled">申し込む/ご契約状況確認</button>
            </p>
          </section>
          <section class="section white-panel mb1p pd4">
            <div class="timy-section mb8 mt8 text-center">
              <img src="/lib/images/carcare_image_reservation.png" class="w80p">
            </div>
            <div v-if="this.isCarMainteDisabled">
              <p>
                <button class="timy-link-button button button-green w80p pd8 radius200 fs14 pb10 pt8" disabled>メニューを見る</button>
              </p>
              <p class="fs13 font-weight-bold color-red2 text-center mb4">当店舗は本サービス非対応店のため<br>ご利用いただけません。</p>
            </div>
            <div v-else>
              <div v-if="webviewMaintenance.carMainte">
                <p class="fs13 font-weight-bold color-red2 text-center mb4">
                  誠に申し訳ありませんが、ただいまメンテナンス<br>中につき、ご利用いただくことが出来ません。<br>お時間をあけてから再度アクセスをお願い致します。
                </p>
              </div>
              <div v-else>
                <p>
                  <button class="timy-link-button button button-green w80p pd8 radius200 fs14 pb10 pt8" v-on:click="timyCarMainteLink()">メニューを見る</button>
                </p>
              </div>
            </div>
          </section>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import inspection from '@/store/Api/inspection'
import manufacturersApi from '@/store/Api/manufacturers'
import modal from '@/assets/v2/modal'
import Loading from '@/views/v2/Loading.vue'
import ssApi from '@/store/Api/Common/ss'
import profileApi from '@/store/Api/Common/profile'
import shopDetailsCallingApi from '@/store/Api/Pitlock/shopDetailsCalling'
import config from '@/v2/config'
import subscription from '@/store/Api/MaintenancePack/subscription'
import userInfo from '@/store/Api/Common/userInfo'
import appVerApi from '@/store/Api/Common/appVer'
import { useSsInfoStore } from '@/store/ssInfo'
import { useProfileInfoStore } from '@/store/profileInfo'
import { useNativeDataStore } from '@/store/nativeData'
import { useVersionDataStore } from '@/store/versionData'

export default {
  data () {
    return {
      loading: true,
      inspectionFlag: true,
      Manufacturer: {},
      profileInfo: [],
      ssInfo: [],
      userInfo: [],
      pitlockshopDetails: {},
      isCarMainteDisabled: false,
      mpDisabled: false,
      moveMpTopButtonDisabled: false,
      webviewMaintenance: []
    }
  },
  methods: {
    ...mapActions('INSPECTION', [
      'setInspection',
      'setDetail'
    ]),
    openErrorModal (message) {
      modal.alert(message)
    },
    eventTrackMoveInspection () {
      this.nativeEVENTSet('ShakenButton', 'MOVED_SYAKEN_TOP', 'TAP')
    },
    eventTrackStartInspectionFromCarcareTop () {
      this.nativeEVENTSet('ShakenButton', 'MOVED_SHAKEN_MITSUMORI_FROM_CARCARE_TOP', 'TAP')
    },
    eventTrackMoveLease () {
      this.nativeEVENTSet('LeaseButton', 'MOVED_LEASE_TOP', 'TAP')
    },
    setProfileInfo (profileInfo) {
      this.profileInfo = profileInfo
    },
    setSsInfo (ssInfo) {
      this.ssInfo = ssInfo
    },
    setUserInfo (userInfo) {
      this.userInfo = userInfo
    },
    setWebviewMaintenance (webviewMaintenance) {
      this.webviewMaintenance = webviewMaintenance
    },
    inspectionTopPage (nativeData, versionData) {
      this.eventTrackMoveInspection()
      this.$router.push({
        name: 'InspectionTopV2',
        query: {
          tsid: nativeData.tsid,
          popinfoid: nativeData.popinfoid,
          otoken: nativeData.otoken,
          x_cls_app_version: versionData.appVersion,
          x_cls_os: versionData.platform,
          x_cls_os_version: versionData.osVersion
        }
      })
    },
    leaseTopPage (nativeData, versionData) {
      this.eventTrackMoveLease()
      this.$router.push({
        name: 'LeaseTopV2',
        query: {
          tsid: nativeData.tsid,
          popinfo_id: nativeData.popinfoid,
          otoken: nativeData.otoken,
          x_cls_app_version: versionData.appVersion,
          x_cls_os: versionData.platform,
          x_cls_os_version: versionData.osVersion
        }
      })
    },
    InspectionDetailPage (ssInfo, profileInfo, nativeData, versionData) {
      const ssInfoStore = useSsInfoStore()
      ssInfoStore.ssInfo = ssInfo
      const profileInfoStore = useProfileInfoStore()
      profileInfoStore.profileInfo = profileInfo
      const nativeDataStore = useNativeDataStore()
      nativeDataStore.nativeData = nativeData
      const versionDataStore = useVersionDataStore()
      versionDataStore.versionData = versionData

      this.$router.push({ name: 'InspectionDetailV2' })
    },
    nextPage (ssInfo, profileInfo, nativeData, versionData) {
      // 条件入力に遷移
      this.eventTrackStartInspectionFromCarcareTop()

      const ssInfoStore = useSsInfoStore()
      ssInfoStore.ssInfo = ssInfo
      const profileInfoStore = useProfileInfoStore()
      profileInfoStore.profileInfo = profileInfo
      const nativeDataStore = useNativeDataStore()
      nativeDataStore.nativeData = nativeData
      const versionDataStore = useVersionDataStore()
      versionDataStore.versionData = versionData

      this.$router.push({ name: 'CarV2' })
    },
    async timyCarMainteLink () {
      $('.timy-link-button').prop('disabled', true)
      await shopDetailsCallingApi.get(this.ssInfo.store_id).then(res => {
        const pitlockshopDetails = res.data.body
        if (pitlockshopDetails.showable !== 1 || pitlockshopDetails.cls_mainte_flag !== 1) {
          this.openErrorModal('サービス準備中のため、申し訳ございませんがお時間をおいて再度お試し下さい。')
        } else {
          const timyCarMainteUrl = process.env.VUE_APP_TIMY_CAR_MAINTE_URL +
                this.ssInfo.store_id + '/?' +
                'reserve_channel=' + config.TIMY_CAR_MAINTE_RESERVE_CHANNEL_CODE +
                '&ts_id=' + this.nativeData.tsid +
                '&popinfo_id=' + this.nativeData.popinfoid +
                '&ss_code=' + this.ssInfo.ss_code +
                config.TIMY_CAR_MAINTE_CF_PARAM
          this.nativeEVENTSet('CarMainte_Button', 'MOVED_CarMainte', 'TAP')
          if ('Android' in window) {
            /* eslint-disable-next-line no-undef */
            Android.openBrowser(timyCarMainteUrl)
          } else if ('webkit' in window) {
            /* eslint-disable-next-line no-undef */
            webkit.messageHandlers.openBrowser.postMessage(timyCarMainteUrl)
          }
        }
      }).catch(e => {
        this.openErrorModal('ただいまアクセスが集中している可能性がございます。恐れ入りますが、時間をおいて再度お試しください。')
      })
      $('.timy-link-button').prop('disabled', false)
    },
    /**
     * メンテパック申し込みTOP画面に遷移させる関数
     */
    maintenancePackTopPage (nativeData, ssCode, versionData) {
      this.nativeEVENTSet('MpButton', 'MOVED_MP_TOP', 'TAP')
      this.$router.push({
        name: 'MaintenancePackTopV2',
        query: {
          tsid: nativeData.tsid,
          popinfoid: nativeData.popinfoid,
          otoken: nativeData.otoken,
          ss_code: ssCode,
          appVersion: versionData.appVersion,
          platform: versionData.platform,
          osVersion: versionData.osVersion
        }
      })
    }
  },
  computed: {
    ...mapGetters('INSPECTION', [
      'inspection',
      'detail'
    ]),
    nativeData: function () {
      const getData = {}
      // ネイティブから取得したデータを格納する。
      getData.tsid = this.$route.query.tsid
      getData.popinfoid = this.$route.query.popinfoid
      getData.otoken = this.$route.query.otoken
      return getData
    },
    versionData: function () {
      const getData = {}
      // ネイティブから取得したデータを格納する。
      getData.appVersion = this.$route.query.x_cls_app_version
      getData.platform = this.$route.query.x_cls_os
      getData.osVersion = this.$route.query.x_cls_os_version
      return getData
    },
    firstRegistrationOnWareki: function () {
      return this.toWareki(this.detail[0].inspection_estimate.first_registration_on)
    }
  },
  async mounted () {
    console.log(location.href)
    // 戻るボタンの出し分け
    this.appDisplayBack(false)
    let isApiError = false

    // webviewメンテナンス情報を取得
    await appVerApi.get().then(res => {
      this.setWebviewMaintenance(res.data.webviewMaintenance)
    }).catch(e => {
      console.log('appVerApi-error')
      console.log(e.message)
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })

    // バージョン情報が一つでも未定義の場合はエラーダイアログを表示.
    if (this.isCLSAppVersionError(this.$route.query.x_cls_app_version, this.$route.query.x_cls_os, this.$route.query.x_cls_os_version)) {
      this.openErrorModal('アプリバージョンの認証でエラーが発生しました。')
      isApiError = true
      return
    } else {
      this.versionData.appVersion = this.versionData.appVersion ? this.versionData.appVersion : '0.0.0'
      this.versionData.platform = this.versionData.platform ? this.versionData.platform : 'iRidge'
      this.versionData.osVersion = this.versionData.osVersion ? this.versionData.osVersion : '0.0'
    }

    // profile情報マスタ取得。
    await profileApi.get(this.nativeData.tsid, this.nativeData.otoken, this.appVersionMakeRequestHeder(this.versionData)).then(res => {
      this.setProfileInfo(res.data.body)
    }).catch(e => {
      console.log('profile-error')
      console.log(e.message)
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })

    // ベストMYSSが存在している場合
    if (this.profileInfo.best_myss.length !== 0) {
      await ssApi.get(this.profileInfo.best_myss.code).then(res => {
        this.setSsInfo(res.data.body.ss_info)
        // store_idが有り、且つカーメンテフラグが対応店の場合のみ、カーメンテメニューボタンを活性
        if (this.ssInfo.is_car_mainte === 1 && this.ssInfo.store_id) {
          this.isCarMainteDisabled = false
        } else {
          this.isCarMainteDisabled = true
        }
      }).catch(e => {
        console.log('ss-error')
        console.log(e.message)
        if (!isApiError) {
          this.openErrorModal('エラーが発生しました。')
          isApiError = true
        }
      })
    }

    // inspection(予約)データ取得
    await inspection.get(this.$route.query.tsid).then(res => {
      this.setInspection(res.data)
    }).catch(e => {
      console.log('inspection-error')
      console.log(e.message)
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })

    if (this.inspection.inspections.length !== 0) this.setDetail((await inspection.getDetail(this.inspection.inspections[0].id)).data)
    if (this.detail[0].id !== '') {
      // 車名（メーカーを取得する）
      await manufacturersApi.getDetail(this.detail[0].inspection_estimate.manufacturer_id).then(res => {
        this.Manufacturer = res.data.manufacturer
      }).catch(e => {
        console.log('manufactuer-error')
        console.log(e.message)
        if (!isApiError) {
          this.openErrorModal('エラーが発生しました。')
          isApiError = true
        }
      })
    } else {
      this.inspectionFlag = false
    }
    // イベントトラッキング
    // 予約がある場合
    if (this.inspectionFlag) {
      if (this.detail[0].id !== '') {
        // 申し込み
        if (this.detail[0].status_code === 1) {
          this.nativeEVENTSet('CarMenu', 'CAR_MENU', 'PAGEVIEW', { shakenStatus: 'Mosikomi' })
        }
        // 日程確定
        if (this.detail[0].status_code === 2) {
          this.nativeEVENTSet('CarMenu', 'CAR_MENU', 'PAGEVIEW', { shakenStatus: 'Nitteikakutei' })
        }
        // お預かり
        if (this.detail[0].status_code === 3) {
          this.nativeEVENTSet('CarMenu', 'CAR_MENU', 'PAGEVIEW', { shakenStatus: 'Azukarityu' })
        }
        // 車検完了
        if (this.detail[0].status_code === 4) {
          this.nativeEVENTSet('CarMenu', 'CAR_MENU', 'PAGEVIEW', { shakenStatus: 'Kanryo' })
        }
        // 支払い完了（現金払い）
        if (this.detail[0].status_code === 5 && this.detail[0].payment_method_code === 2) {
          this.nativeEVENTSet('CarMenu', 'CAR_MENU', 'PAGEVIEW', { shakenStatus: 'Cash' })
        }
        // 支払い完了（クレジット払い）
        if (this.detail[0].status_code === 5 && this.detail[0].payment_method_code === 1) {
          this.nativeEVENTSet('CarMenu', 'CAR_MENU', 'PAGEVIEW', { shakenStatus: 'Credit' })
        }
      }
    }
    this.nativePVset('CAR_MENU')

    // メンテパック対応店の場合、メンテパックバナー・申し込みボタン表示
    if (this.ssInfo.mp_type_flag === config.MAINTENANCE_PACK_CORRESPONDENCE) {
      this.mpDisabled = true
      // ユーザー情報取得
      const xAppVersion = `${this.versionData.appVersion}/${this.versionData.platform}/${this.versionData.osVersion}`
      await userInfo.get(this.nativeData, xAppVersion).then(res => {
        this.setUserInfo(res.data.body.id)
      }).catch(e => {
        console.log('userInfo-error')
        console.log(e)
        if (!isApiError) {
          this.openErrorModal('エラーが発生しました。')
          isApiError = true
        }
      })

      // ログインユーザーの場合メンテパック申込情報取得
      if (this.userInfo.authid) {
        const queryParameter = `?authid=${this.userInfo.authid}`
        await subscription.get(queryParameter).then(res => {
          if (res.data[0]) {
            if (res.data[0].maintenance_pack_subscription.ss_code !== this.ssInfo.ss_code) {
              this.moveMpTopButtonDisabled = true
            }
          }
        }).catch(e => {
          console.log('subscription-error')
          console.log(e.message)
          if (!isApiError) {
            this.openErrorModal('エラーが発生しました。')
            isApiError = true
          }
        })
      }
    }

    if (!isApiError) {
      this.loading = false
    }
  },
  components: {
    Loading
  }
}

</script>
